import { useCallback, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { IntervalReport } from 'api/intervals-report';
import { KeyEventsReportAPI } from 'api/key-events-report';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { Empty, Loaded, Loading, Content } from 'stores/core';

export const useKeyEventsReport = (
  range,
  { criteria, type },
  group,
  isInitialized,
) => {
  const [keyEventsReport, setKeyEventsReport] = useState<
    Content<IntervalReport[]>
  >(Loading());

  const validFilters = useMemo(
    () =>
      criteria.filter((item) => item.value !== -1).filter(FieldFilter.isValid),
    [criteria],
  );

  const getKeyEventsReportsData = useCallback(
    () =>
      KeyEventsReportAPI.getReports(range, validFilters, type, group)
        .then((records) =>
          records.length > 0
            ? setKeyEventsReport(Loaded(records))
            : setKeyEventsReport(Empty()),
        )
        .catch(() => {}),
    [range, type, validFilters, group],
  );

  const response = useQuery(
    [`key-events-reports-${group}`, { validFilters, range }],
    getKeyEventsReportsData,
  );

  useDeepCompareEffect(() => {
    if (!isInitialized) {
      return;
    }
    setKeyEventsReport(Loading());
    response.refetch();
  }, [range, type, validFilters, isInitialized]);

  return keyEventsReport;
};
